// src/pages/Veiculos.js

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../services/api';
import './Veiculos.css';
import * as XLSX from 'xlsx';

// Componentes Filhos
import VeiculoCard from '../components/VeiculoCard';
import VeiculoDetalhesModal from '../components/VeiculoDetalhesModal';
import VeiculoEditModal from '../components/VeiculoEditModal';
import AbastecimentoLoteModal from '../components/AbastecimentoLoteModal';
import AbastecimentoManualModal from '../components/AbastecimentoManualModal';
import MonitorUsoDiarioModal from '../components/MonitorUsoDiarioModal';
import SuccessModal from './SuccessModal';

// Ícones
import {
    FaTruck, FaPlus, FaSearch, FaDownload, FaCarSide,
    FaFileExport, FaFileImport, FaArrowLeft, FaSpinner,
    FaTh, FaList, FaCheckSquare, FaRegSquare,
    FaEdit, FaTrash, FaEye, FaTimes,
    FaUserClock, FaGasPump, FaBars, FaWrench,
    FaCloudUploadAlt, FaFileDownload, FaFileExcel,
    FaCheckCircle, FaExclamationTriangle, FaListUl,
    FaRoad, FaInfoCircle,
} from 'react-icons/fa';

const isPlanilhaValida = (file) => {
    if (!file?.name) return false;
    return ['.xlsx', '.xls', '.csv'].some((ext) => file.name.toLowerCase().endsWith(ext));
};

// Badge de tipo de uso Sem Parar — exibido no resultado da importação
function SpTipoBadge({ tipo }) {
    const map = {
        'PASSAGENS':        { bg: '#1e40af', label: '🛣️ Pedágios' },
        'ESTACIONAMENTO':   { bg: '#065f46', label: '🅿️ Estacionamentos' },
        'PLANO CONTRATADO': { bg: '#6b21a8', label: '📋 Plano Contratado' },
        'ABASTECIMENTO':    { bg: '#92400e', label: '⛽ Abastecimento' },
    };
    const cfg = map[tipo] || { bg: '#374151', label: tipo };
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            background: cfg.bg, color: '#fff',
            padding: '2px 10px', borderRadius: 999,
            fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.02em',
        }}>
            {cfg.label}
        </span>
    );
}

export default function Veiculos() {
    const navigate = useNavigate();

    // ── Refs de upload ──
    const fileInputRef      = useRef(null); // veículos
    const fileInputAbastRef = useRef(null); // abastecimentos global
    const mfFileRef         = useRef(null); // manutenções frota global
    const spFileRef         = useRef(null); // Sem Parar global  ← NOVO
    const acoesMenuRef      = useRef(null); // clique fora do menu

    // ── Estados principais ──
    const [veiculos, setVeiculos]         = useState([]);
    const [motoristas, setMotoristas]     = useState([]);
    const [pagination, setPagination]     = useState({ currentPage: 1, total: 0, perPage: 12, totalPages: 1 });
    const [isLoading, setIsLoading]       = useState(true);
    const [error, setError]               = useState(null);
    const [userProfile, setUserProfile]   = useState('admin_geral');
    const [searchQuery, setSearchQuery]   = useState('');

    // Controles de view e seleção
    const [viewMode, setViewMode]                 = useState('grid');
    const [selectedVehicles, setSelectedVehicles] = useState([]);

    // Modais
    const [isAddModalOpen, setIsAddModalOpen]               = useState(false);
    const [selectedVeiculo, setSelectedVeiculo]             = useState(null);
    const [editingVeiculo, setEditingVeiculo]               = useState(null);
    const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
    const [successMessage, setSuccessMessage]               = useState('');
    const [showMonitor, setShowMonitor]                     = useState(false);
    const [isLoteAbastecimentoOpen, setIsLoteAbastecimentoOpen] = useState(false);
    const [isAbastManualOpen, setIsAbastManualOpen]             = useState(false);

    // Formulário de novo veículo
    const initialFormState = { placa: '', modelo: '', marca: '', ano: '', status: 'Disponível', motorista_id: '' };
    const [formData, setFormData]               = useState(initialFormState);
    const [isConsultingPlaca, setIsConsultingPlaca] = useState(false);
    const [isSubmitting, setIsSubmitting]       = useState(false);

    // Importação de veículos
    const [isImporting, setIsImporting] = useState(false);

    // Badge monitor diário
    const [monitorBadge, setMonitorBadge] = useState(0);

    // AcoesMenu
    const [acoesMenuOpen, setAcoesMenuOpen] = useState(false);

    // Importação global de abastecimentos (BLB)
    const [isImportingAbast, setIsImportingAbast] = useState(false);

    // Importação global de manutenções frota
    const [mfImportOpen, setMfImportOpen]   = useState(false);
    const [mfVeiculoId, setMfVeiculoId]     = useState('');
    const [mfFile, setMfFile]               = useState(null);
    const [mfIsImporting, setMfIsImporting] = useState(false);
    const [mfIsDragging, setMfIsDragging]   = useState(false);
    const [mfResult, setMfResult]           = useState(null);
    const [mfShowErros, setMfShowErros]     = useState(false);

    // Importação global de abastecimentos (modal BLB / Sem Parar antigo)
    const [abastImportOpen, setAbastImportOpen] = useState(false);
    const [abastFormato, setAbastFormato]       = useState('blb');
    const [abastFile, setAbastFile]             = useState(null);
    const [abastIsDragging, setAbastIsDragging] = useState(false);
    const [abastResult, setAbastResult]         = useState(null);
    const [abastShowErros, setAbastShowErros]   = useState(false);

    // ── Importação Sem Parar dedicada (extrato real → gastos_sem_parar) ── NOVO
    const [spImportOpen, setSpImportOpen]     = useState(false);
    const [spFile, setSpFile]                 = useState(null);
    const [spIsDragging, setSpIsDragging]     = useState(false);
    const [spResult, setSpResult]             = useState(null);
    const [spShowErros, setSpShowErros]       = useState(false);
    const [spIsImporting, setSpIsImporting]   = useState(false);

    // ─────────────────────────────────────────────────────────────────────────
    // Effects
    // ─────────────────────────────────────────────────────────────────────────

    useEffect(() => {
        if (!acoesMenuOpen) return;
        const handler = (e) => {
            if (acoesMenuRef.current && !acoesMenuRef.current.contains(e.target)) {
                setAcoesMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [acoesMenuOpen]);

    useEffect(() => {
        const check = async () => {
            try {
                const { data } = await api.get('/api/vehicles/monitor-diario');
                setMonitorBadge(data.discrepancias?.length || 0);
            } catch { /* silencioso */ }
        };
        check();
        const iv = setInterval(check, 60_000);
        return () => clearInterval(iv);
    }, []);

    // ─────────────────────────────────────────────────────────────────────────
    // Consulta automática de placa
    // ─────────────────────────────────────────────────────────────────────────
    const autoConsultaPlaca = async (placa) => {
        if (isConsultingPlaca) return;
        setIsConsultingPlaca(true);
        try {
            const { data } = await api.get(`/api/vehicles/consultar-placa?placa=${placa}`);
            setFormData((prev) => ({ ...prev, marca: data.marca || '', modelo: data.modelo || '', ano: data.ano || '' }));
        } catch { /* silencioso */ }
        finally { setIsConsultingPlaca(false); }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Carregamento de dados
    // ─────────────────────────────────────────────────────────────────────────
    const fetchUserData = async () => {
        try {
            const { data } = await api.get('/api/usuarios/me');
            setUserProfile(data.perfil);
        } catch (err) { console.error('Erro ao buscar perfil:', err); }
    };

    const fetchVeiculos = useCallback(async (page = 1) => {
        setIsLoading(true);
        setError(null);
        try {
            const { data } = await api.get('/api/vehicles', {
                params: { page, limit: pagination.perPage, query: searchQuery },
            });
            setVeiculos(data.data || []);
            setPagination((prev) => ({ ...prev, ...data.pagination, currentPage: page }));
            setSelectedVehicles([]);
        } catch { setError('Falha ao carregar a frota.'); }
        finally { setIsLoading(false); }
    }, [pagination.perPage, searchQuery]);

    const fetchMotoristas = async () => {
        try {
            const { data } = await api.get('/api/drivers', { params: { limit: 1000 } });
            setMotoristas(data.data || []);
        } catch (err) { console.error('Erro ao buscar motoristas:', err); }
    };

    useEffect(() => { fetchUserData(); fetchMotoristas(); }, []);
    useEffect(() => {
        const t = setTimeout(() => fetchVeiculos(1), 300);
        return () => clearTimeout(t);
    }, [searchQuery, fetchVeiculos]);

    // ─────────────────────────────────────────────────────────────────────────
    // Seleção em massa
    // ─────────────────────────────────────────────────────────────────────────
    const handleToggleSelect = (id) =>
        setSelectedVehicles((prev) =>
            prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
        );

    const handleSelectAll = () =>
        setSelectedVehicles(selectedVehicles.length === veiculos.length ? [] : veiculos.map((v) => v.id));

    const handleMassDelete = async () => {
        if (!window.confirm(`Excluir permanentemente ${selectedVehicles.length} veículo(s)?`)) return;
        setIsLoading(true);
        try {
            await Promise.all(selectedVehicles.map((id) => api.delete(`/api/vehicles/${id}`)));
            setSuccessMessage(`${selectedVehicles.length} veículos removidos com sucesso.`);
            setIsSuccessModalVisible(true);
            fetchVeiculos(1);
        } catch {
            alert('Aviso: Alguns veículos não puderam ser excluídos pois possuem histórico vinculado.');
            fetchVeiculos(pagination.currentPage);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // CRUD de veículo
    // ─────────────────────────────────────────────────────────────────────────
    const handleOpenAddModal  = () => setIsAddModalOpen(true);
    const handleCloseAddModal = () => { setIsAddModalOpen(false); setFormData(initialFormState); };
    const handleOpenViewModal = (id) => setSelectedVeiculo(veiculos.find((v) => v.id === id));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const final = name === 'placa' ? value.toUpperCase().replace(/[^A-Z0-9]/g, '') : value;
        setFormData((prev) => ({ ...prev, [name]: final }));
        if (name === 'placa' && final.length === 7) autoConsultaPlaca(final);
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await api.post('/api/vehicles', formData);
            setSuccessMessage('Veículo adicionado à frota com sucesso!');
            setIsSuccessModalVisible(true);
            handleCloseAddModal();
            fetchVeiculos(1);
        } catch { alert('Erro ao cadastrar veículo. Verifique se a placa já existe.'); }
        finally { setIsSubmitting(false); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Deseja realmente remover este veículo da frota?')) return;
        try {
            await api.delete(`/api/vehicles/${id}`);
            setSuccessMessage('Veículo excluído com sucesso!');
            setIsSuccessModalVisible(true);
            const isLast = veiculos.length === 1 && pagination.currentPage > 1;
            fetchVeiculos(isLast ? pagination.currentPage - 1 : pagination.currentPage);
        } catch { alert('Erro ao excluir veículo. Verifique se há histórico ativo.'); }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Exportação de frota
    // ─────────────────────────────────────────────────────────────────────────
    const handleExport = (format) => {
        if (veiculos.length === 0) return alert('Não há dados para exportar.');
        const rows = veiculos.map((v) => ({
            Placa: v.placa, Modelo: v.modelo, Marca: v.marca,
            Ano: v.ano, Status: v.status, Motorista: v.motorista_nome || 'Nenhum',
        }));
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Frota');
        if (format === 'xlsx') {
            XLSX.writeFile(wb, `frota_${Date.now()}.xlsx`);
        } else {
            const csv = XLSX.utils.sheet_to_csv(ws);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `frota_${Date.now()}.csv`;
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Modelo / importação — Veículos
    // ─────────────────────────────────────────────────────────────────────────
    const handleDownloadTemplate = (format) => {
        const header  = ['placa', 'modelo', 'marca', 'ano', 'status', 'motorista_id'];
        const example = ['ABC1234', 'Caminhão Guincho', 'Volkswagen', '2024', 'Disponível', ''];
        if (format === 'csv') {
            const csv = [header.join(','), example.join(',')].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = 'modelo_veiculos.csv'; a.click();
        } else {
            const ws = XLSX.utils.aoa_to_sheet([header, example]);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Veiculos');
            XLSX.writeFile(wb, 'modelo_veiculos.xlsx');
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const fd = new FormData();
        fd.append('file', file);
        setIsImporting(true);
        try {
            const { data } = await api.post('/api/vehicles/import', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setSuccessMessage(data.message || 'Importação concluída!');
            setIsSuccessModalVisible(true);
            fetchVeiculos(1);
        } catch { alert('Erro na importação. Verifique os dados do arquivo.'); }
        finally {
            setIsImporting(false);
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Modelo / importação — Abastecimentos (global, modal BLB)
    // ─────────────────────────────────────────────────────────────────────────
    const handleDownloadTemplateAbast = () => {
        const header  = ['placa', 'data', 'litros', 'valor', 'odometro', 'tipo_combustivel', 'posto', 'observacao'];
        const example = ['ABC1D23', '2025-06-01', '50.00', '380.00', '158420', 'Diesel', 'Posto BR', ''];
        const ws = XLSX.utils.aoa_to_sheet([header, example]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Abastecimentos');
        XLSX.writeFile(wb, 'modelo_abastecimentos_frota.xlsx');
    };

    const handleAbastFileSelect = (file) => {
        if (!file) return;
        if (!isPlanilhaValida(file)) { toast.warning('Use um arquivo .xlsx, .xls ou .csv.'); return; }
        setAbastFile(file);
        setAbastResult(null);
        setAbastShowErros(false);
    };

    const closeAbastImportModal = () => {
        setAbastImportOpen(false);
        setAbastFormato('blb');
        setAbastFile(null);
        setAbastResult(null);
        setAbastShowErros(false);
        setAbastIsDragging(false);
        if (fileInputAbastRef.current) fileInputAbastRef.current.value = '';
    };

    const executarImportAbast = async () => {
        if (!abastFile) { toast.warning('Selecione uma planilha para importar.'); return; }
        setIsImportingAbast(true);
        setAbastResult(null);
        const fd = new FormData();
        fd.append('file', abastFile);
        const endpoint =
            abastFormato === 'sem_parar'
                ? '/api/vehicles/abastecimentos/import-sem-parar'
                : '/api/vehicles/abastecimentos/import';
        try {
            const { data } = await api.post(endpoint, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            const inseridos  = data?.inseridos  ?? 0;
            const ignorados  = data?.ignorados  ?? 0;
            const duplicados = data?.duplicados ?? 0;
            setAbastResult({
                status: ignorados > 0 ? 'partial' : 'ok',
                message: data?.message || 'Importação concluída.',
                inseridos, ignorados, duplicados,
                detalhes: data?.detalhes || [],
            });
            if (inseridos > 0) {
                toast.success(data?.message || `${inseridos} abastecimento(s) importado(s)!`);
                setAbastFile(null);
                if (fileInputAbastRef.current) fileInputAbastRef.current.value = '';
                fetchVeiculos(pagination.currentPage);
            } else {
                toast.warning('Nenhuma linha foi importada. Confira os detalhes.');
            }
            if (ignorados > 0) setAbastShowErros(true);
        } catch (err) {
            const resp = err?.response?.data;
            setAbastResult({
                status: 'err',
                message: resp?.error || 'Falha ao importar a planilha.',
                inseridos: 0, ignorados: resp?.detalhes?.length || 0, duplicados: 0,
                detalhes: resp?.detalhes || [],
            });
            if ((resp?.detalhes || []).length) setAbastShowErros(true);
            toast.error(resp?.error || 'Falha ao importar a planilha.');
        } finally {
            setIsImportingAbast(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Modelo / importação — Manutenções Frota
    // ─────────────────────────────────────────────────────────────────────────
    const handleDownloadTemplateMf = (placa = 'frota') => {
        const hoje = new Date().toISOString().slice(0, 10);
        const headers = ['data', 'servico', 'valor', 'oficina', 'cnpj', 'descricao'];
        const exemplos = [
            [hoje, 'Troca de óleo e filtros', '380.00', 'Auto Center Silva', '', 'Óleo 15W40 + filtro de óleo e ar'],
            [hoje, 'Revisão de freios',       '950.00', 'Oficina do Zé',     '', 'Pastilhas dianteiras e sangria'],
        ];
        const escapar = (c) => {
            const s = String(c ?? '');
            return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        };
        const linhas = [headers, ...exemplos].map((cols) => cols.map(escapar).join(','));
        const csv = '\uFEFF' + linhas.join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `modelo_manutencoes_${String(placa).toUpperCase()}.csv`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const handleMfFileSelect = (file) => {
        if (!file) return;
        if (!isPlanilhaValida(file)) { toast.warning('Use .xlsx, .xls ou .csv.'); return; }
        setMfFile(file);
        setMfResult(null);
        setMfShowErros(false);
    };

    const closeMfImportModal = () => {
        setMfImportOpen(false);
        setMfVeiculoId('');
        setMfFile(null);
        setMfResult(null);
        setMfShowErros(false);
        setMfIsDragging(false);
        if (mfFileRef.current) mfFileRef.current.value = '';
    };

    const handleImportManutencoesFrota = async () => {
        if (!mfVeiculoId) { toast.warning('Selecione um veículo antes de importar.'); return; }
        if (!mfFile)      { toast.warning('Selecione uma planilha para importar.'); return; }

        setMfIsImporting(true);
        setMfResult(null);
        const fd = new FormData();
        fd.append('file', mfFile);

        try {
            const { data } = await api.post(
                `/api/vehicles/${mfVeiculoId}/manutencoes-frota/import`,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            const inseridos  = data?.inseridos  ?? 0;
            const ignorados  = data?.ignorados  ?? 0;
            const duplicados = data?.duplicados ?? 0;
            setMfResult({
                status: ignorados > 0 ? 'partial' : 'ok',
                message: data?.message || 'Importação concluída.',
                inseridos, ignorados, duplicados,
                detalhes: data?.detalhes || [],
            });
            if (inseridos > 0) {
                toast.success(data?.message || `${inseridos} manutenção(ões) importada(s)!`);
                setMfFile(null);
                if (mfFileRef.current) mfFileRef.current.value = '';
            } else {
                toast.warning('Nenhuma linha foi importada. Confira os detalhes.');
            }
            if (ignorados > 0) setMfShowErros(true);
        } catch (err) {
            const resp = err?.response?.data;
            setMfResult({
                status: 'err',
                message: resp?.error || 'Falha ao importar a planilha.',
                inseridos: 0, ignorados: resp?.detalhes?.length || 0, duplicados: 0,
                detalhes: resp?.detalhes || [],
            });
            if ((resp?.detalhes || []).length) setMfShowErros(true);
            toast.error(resp?.error || 'Falha ao importar a planilha.');
        } finally {
            setMfIsImporting(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Importação Sem Parar — extrato real (gastos_sem_parar)   ← NOVO
    // ─────────────────────────────────────────────────────────────────────────
    const handleSpFileSelect = (file) => {
        if (!file) return;
        if (!isPlanilhaValida(file)) { toast.warning('Use um arquivo .xlsx, .xls ou .csv.'); return; }
        setSpFile(file);
        setSpResult(null);
        setSpShowErros(false);
    };

    const closeSpImportModal = () => {
        setSpImportOpen(false);
        setSpFile(null);
        setSpResult(null);
        setSpShowErros(false);
        setSpIsDragging(false);
        if (spFileRef.current) spFileRef.current.value = '';
    };

    const executarImportSemParar = async () => {
        if (!spFile) { toast.warning('Selecione o extrato do Sem Parar para importar.'); return; }

        setSpIsImporting(true);
        setSpResult(null);

        const fd = new FormData();
        fd.append('file', spFile);

        try {
            const { data } = await api.post(
                '/api/vehicles/sem-parar/import',
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            const inseridos    = data?.inseridos    ?? 0;
            const ignorados    = data?.ignorados    ?? 0;
            const duplicados   = data?.duplicados   ?? 0;
            const semVeiculo   = data?.sem_veiculo  ?? 0;
            const detalhes     = data?.detalhes     || [];

            // Status: ok / partial (avisos de placa/erro) / err
            const temErrosReais   = detalhes.filter((d) => !d.startsWith('Aviso:')).length > 0;
            const temAvisos       = detalhes.filter((d) =>  d.startsWith('Aviso:')).length > 0;

            setSpResult({
                status:      inseridos > 0 ? (temErrosReais || temAvisos ? 'partial' : 'ok') : 'err',
                message:     data?.message || 'Importação concluída.',
                inseridos,
                ignorados,
                duplicados,
                semVeiculo,
                erros:       detalhes.filter((d) => !d.startsWith('Aviso:')),
                avisos:      detalhes.filter((d) =>  d.startsWith('Aviso:')),
            });

            if (inseridos > 0) {
                toast.success(data?.message || `${inseridos} lançamento(s) importado(s) do Sem Parar!`);
                setSpFile(null);
                if (spFileRef.current) spFileRef.current.value = '';
            } else {
                toast.warning('Nenhum lançamento foi importado. Confira os detalhes.');
            }

            if (temErrosReais) setSpShowErros(true);
        } catch (err) {
            const resp = err?.response?.data;
            const detalhesBrutos = resp?.detalhes || [];
            setSpResult({
                status:    'err',
                message:   resp?.error || 'Falha ao importar o extrato.',
                inseridos: 0,
                ignorados: detalhesBrutos.length,
                duplicados: 0,
                semVeiculo: 0,
                erros:     detalhesBrutos,
                avisos:    [],
            });
            if (detalhesBrutos.length) setSpShowErros(true);
            toast.error(resp?.error || 'Falha ao importar o extrato Sem Parar.');
        } finally {
            setSpIsImporting(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    // Paginação
    // ─────────────────────────────────────────────────────────────────────────
    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.totalPages && page !== pagination.currentPage) {
            fetchVeiculos(page);
        }
    };

    const hasAdminPermission  = userProfile === 'admin_geral' || userProfile === 'admin';
    const canImportExport     = userProfile === 'admin_geral';
    const mfVeiculoSelecionado = veiculos.find((v) => String(v.id) === String(mfVeiculoId));

    // ─────────────────────────────────────────────────────────────────────────
    // RENDER
    // ─────────────────────────────────────────────────────────────────────────
    return (
        <main className="vec-page-wrapper">

            {/* Inputs ocultos */}
            <input type="file" ref={fileInputRef} onChange={handleImport} style={{ display: 'none' }} accept=".csv,.xlsx" />

            {/* ══════════════════════════════════════════════════
                CABEÇALHO
            ══════════════════════════════════════════════════ */}
            <header className="vec-header">
                <div className="vec-header-title-box">
                    <button onClick={() => navigate(-1)} className="vec-btn-back" aria-label="Voltar">
                        <FaArrowLeft />
                    </button>
                    <div>
                        <div className="vec-title-row">
                            <h1 className="vec-title">Gestão de Frota</h1>
                        </div>
                        <p className="vec-subtitle">Gerencie seus veículos, documentações e gastos com manutenção.</p>
                    </div>
                </div>

                <div className="vec-header-actions">

                    {/* ── ACOES MENU (3 barras) ── */}
                    {canImportExport && (
                        <div className="vec-acoes-wrapper" ref={acoesMenuRef}>
                            <button
                                type="button"
                                className="vec-btn vec-btn-outline"
                                onClick={() => setAcoesMenuOpen((v) => !v)}
                                title="Importar, exportar e baixar modelos"
                                disabled={isImporting || isImportingAbast || spIsImporting}
                            >
                                {(isImporting || isImportingAbast || spIsImporting) ? <FaSpinner className="fa-spin" /> : <FaBars />}
                                {(isImporting || isImportingAbast || spIsImporting) ? 'Importando...' : 'Ações'}
                            </button>

                            {acoesMenuOpen && (
                                <div className="vec-acoes-dropdown animate-fade-in">

                                    {/* Veículos */}
                                    <div className="vec-acoes-section">
                                        <span className="vec-acoes-section-label"><FaTruck /> Veículos</span>
                                        <button className="vec-acoes-item vec-acoes-item--veiculo" onClick={() => { fileInputRef.current?.click(); setAcoesMenuOpen(false); }}>
                                            <FaFileImport /> Importar planilha
                                        </button>
                                        <button className="vec-acoes-item vec-acoes-item--download" onClick={() => { handleDownloadTemplate('xlsx'); setAcoesMenuOpen(false); }}>
                                            <FaFileDownload /> Baixar modelo .xlsx
                                        </button>
                                        <button className="vec-acoes-item vec-acoes-item--export" onClick={() => { handleDownloadTemplate('csv'); setAcoesMenuOpen(false); }}>
                                            <FaFileDownload /> Baixar modelo .csv
                                        </button>
                                    </div>

                                    <hr className="vec-acoes-divider" />

                                    {/* Abastecimentos */}
                                    <div className="vec-acoes-section">
                                        <span className="vec-acoes-section-label"><FaGasPump /> Abastecimentos</span>
                                        <button className="vec-acoes-item vec-acoes-item--abast" onClick={() => { setIsAbastManualOpen(true); setAcoesMenuOpen(false); }}>
                                            <FaPlus /> Lançar manual
                                        </button>
                                        <button className="vec-acoes-item vec-acoes-item--abast" onClick={() => { setAbastImportOpen(true); setAcoesMenuOpen(false); }}>
                                            <FaFileImport /> Importar planilha BLB
                                        </button>
                                    </div>

                                    <hr className="vec-acoes-divider" />

                                    {/* ── SEM PARAR ── NOVO */}
                                    <div className="vec-acoes-section">
                                        <span className="vec-acoes-section-label"><FaRoad /> Sem Parar</span>
                                        <button
                                            className="vec-acoes-item vec-acoes-item--sp"
                                            onClick={() => { setSpImportOpen(true); setAcoesMenuOpen(false); }}
                                        >
                                            <FaFileImport /> Importar extrato
                                        </button>
                                    </div>

                                    <hr className="vec-acoes-divider" />

                                    {/* Manutenções */}
                                    <div className="vec-acoes-section">
                                        <span className="vec-acoes-section-label"><FaWrench /> Manutenções</span>
                                        <button className="vec-acoes-item vec-acoes-item--manut" onClick={() => { setMfImportOpen(true); setAcoesMenuOpen(false); }}>
                                            <FaFileImport /> Importar planilha
                                        </button>
                                        <button className="vec-acoes-item vec-acoes-item--export" onClick={() => { handleDownloadTemplateMf(); setAcoesMenuOpen(false); }}>
                                            <FaFileDownload /> Baixar modelo .csv
                                        </button>
                                    </div>

                                    <hr className="vec-acoes-divider" />

                                    {/* Exportar */}
                                    <div className="vec-acoes-section">
                                        <span className="vec-acoes-section-label"><FaFileExport /> Exportar Frota</span>
                                        <button className="vec-acoes-item vec-acoes-item--download" onClick={() => { handleExport('xlsx'); setAcoesMenuOpen(false); }}>
                                            <FaDownload /> Exportar .xlsx
                                        </button>
                                        <button className="vec-acoes-item vec-acoes-item--export" onClick={() => { handleExport('csv'); setAcoesMenuOpen(false); }}>
                                            <FaDownload /> Exportar .csv
                                        </button>
                                    </div>

                                </div>
                            )}
                        </div>
                    )}

                    {/* Monitor Diário */}
                    {hasAdminPermission && (
                        <button
                            type="button"
                            onClick={() => setShowMonitor(true)}
                            className="vec-btn vec-btn-outline vec-btn-monitor"
                            title="Abrir monitor de uso diário dos veículos"
                        >
                            <FaUserClock />
                            Monitor Diário
                            {monitorBadge > 0 && <span className="vec-monitor-badge">{monitorBadge}</span>}
                        </button>
                    )}

                    {/* Novo Veículo */}
                    <button type="button" onClick={handleOpenAddModal} className="vec-btn vec-btn-primary">
                        <FaPlus /> Novo Veículo
                    </button>
                </div>
            </header>

            {/* ══════════════════════════════════════════════════
                BARRA DE AÇÕES EM MASSA
            ══════════════════════════════════════════════════ */}
            {selectedVehicles.length > 0 && hasAdminPermission && (
                <div className="vec-mass-action-bar animate-slide-down">
                    <div className="vec-mass-action-info">
                        <span className="vec-mass-count">{selectedVehicles.length}</span> selecionado(s)
                    </div>
                    <div className="vec-mass-action-buttons">
                        <button onClick={() => setSelectedVehicles([])} className="vec-btn vec-btn-outline">Cancelar</button>
                        <button onClick={() => setIsLoteAbastecimentoOpen(true)} className="vec-btn vec-btn-outline">
                            <FaGasPump /> Abastecer
                        </button>
                        <button onClick={handleMassDelete} className="vec-btn vec-btn-danger">
                            <FaTrash /> Excluir
                        </button>
                    </div>
                </div>
            )}

            {/* ══════════════════════════════════════════════════
                BUSCA E VISUALIZAÇÃO
            ══════════════════════════════════════════════════ */}
            <section className="vec-search-section">
                <div className="vec-search-box">
                    <FaSearch className="vec-search-icon" />
                    <input
                        type="text"
                        className="vec-search-input"
                        placeholder="Buscar por placa, modelo ou marca..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <div className="vec-search-controls">
                    {hasAdminPermission && veiculos.length > 0 && !isLoading && (
                        <button onClick={handleSelectAll} className="vec-select-all-btn">
                            {selectedVehicles.length === veiculos.length
                                ? <FaCheckSquare className="text-blue" />
                                : <FaRegSquare />}
                            Todos
                        </button>
                    )}
                    <div className="vec-view-toggle">
                        <button className={`vec-view-btn ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')}><FaTh /></button>
                        <button className={`vec-view-btn ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}><FaList /></button>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════
                CONTEÚDO PRINCIPAL
            ══════════════════════════════════════════════════ */}
            <section className="vec-content-card">
                <h3 className="vec-card-title"><FaTruck /> Frota Ativa ({pagination.total})</h3>

                {isLoading ? (
                    <div className="vec-state-box"><div className="vec-spinner"></div><p>Sincronizando frota...</p></div>
                ) : error ? (
                    <div className="vec-state-box error"><p>{error}</p></div>
                ) : veiculos.length === 0 ? (
                    <div className="vec-state-box"><FaCarSide className="vec-empty-icon" /><p>Nenhum veículo encontrado.</p></div>
                ) : (
                    <>
                        {viewMode === 'grid' ? (
                            <div className="vec-grid-container animate-fade-in">
                                {veiculos.map((v) => (
                                    <VeiculoCard
                                        key={v.id}
                                        veiculo={v}
                                        isSelected={selectedVehicles.includes(v.id)}
                                        onToggleSelect={() => handleToggleSelect(v.id)}
                                        hasAdminPermission={hasAdminPermission}
                                        onViewDetails={() => handleOpenViewModal(v.id)}
                                        onEdit={() => setEditingVeiculo(v)}
                                        onDelete={() => handleDelete(v.id)}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="vec-table-wrapper animate-fade-in">
                                <table className="vec-table">
                                    <thead>
                                        <tr>
                                            {hasAdminPermission && <th width="40"></th>}
                                            <th>Veículo</th>
                                            <th>Placa</th>
                                            <th>Status</th>
                                            <th className="text-right">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {veiculos.map((v) => {
                                            const isSelected  = selectedVehicles.includes(v.id);
                                            const statusClass = v.status?.toLowerCase()
                                                .replace(/ /g, '-')
                                                .replace('ç', 'c').replace('í', 'i').replace('ã', 'a');
                                            return (
                                                <tr key={v.id} className={isSelected ? 'selected-row' : ''}>
                                                    {hasAdminPermission && (
                                                        <td onClick={() => handleToggleSelect(v.id)} className="vec-table-checkbox">
                                                            {isSelected ? <FaCheckSquare className="checked" /> : <FaRegSquare />}
                                                        </td>
                                                    )}
                                                    <td>
                                                        <div className="vec-table-info">
                                                            <strong>{v.marca} {v.modelo}</strong>
                                                            <span>Ano {v.ano}</span>
                                                        </div>
                                                    </td>
                                                    <td><span className="vec-table-badge-placa">{v.placa}</span></td>
                                                    <td><span className={`vec-status-badge status-${statusClass}`}>{v.status}</span></td>
                                                    <td>
                                                        <div className="vec-table-actions">
                                                            <button onClick={() => handleOpenViewModal(v.id)} className="vec-icon-btn view" title="Detalhes"><FaEye /></button>
                                                            {hasAdminPermission && (
                                                                <>
                                                                    <button onClick={() => setEditingVeiculo(v)} className="vec-icon-btn edit" title="Editar"><FaEdit /></button>
                                                                    <button onClick={() => handleDelete(v.id)} className="vec-icon-btn delete" title="Excluir"><FaTrash /></button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </>
                )}

                {!isLoading && veiculos.length > 0 && pagination.totalPages > 1 && (
                    <nav className="vec-pagination">
                        <button onClick={() => handlePageChange(pagination.currentPage - 1)} disabled={pagination.currentPage <= 1}>Anterior</button>
                        <span>Página <strong>{pagination.currentPage}</strong> de <strong>{pagination.totalPages}</strong></span>
                        <button onClick={() => handlePageChange(pagination.currentPage + 1)} disabled={pagination.currentPage >= pagination.totalPages}>Próxima</button>
                    </nav>
                )}
            </section>

            {/* ══════════════════════════════════════════════════
                MODAL — ADICIONAR VEÍCULO
            ══════════════════════════════════════════════════ */}
            {isAddModalOpen && (
                <div className="vec-modal-overlay" onClick={handleCloseAddModal}>
                    <div className="vec-modal-content" onClick={(e) => e.stopPropagation()}>
                        <header className="vec-modal-header">
                            <h2><FaCarSide /> Novo Veículo</h2>
                            <button className="vec-close" onClick={handleCloseAddModal}><FaTimes /></button>
                        </header>
                        <form onSubmit={handleAddSubmit} className="vec-modal-form vec-form">
                            <div className="vec-modal-body">
                                <div className="vec-form-group">
                                    <label>Placa (Busca automática)</label>
                                    <div className="vec-input-with-icon">
                                        <FaSearch className="vec-inner-icon" />
                                        <input
                                            type="text" name="placa"
                                            placeholder="Digite a placa..."
                                            value={formData.placa} onChange={handleInputChange}
                                            required maxLength="7" autoComplete="off"
                                        />
                                        {isConsultingPlaca && <FaSpinner className="vec-spin-loader" />}
                                    </div>
                                </div>
                                <div className="vec-form-row">
                                    <div className="vec-form-group">
                                        <label>Marca</label>
                                        <input type="text" name="marca" value={formData.marca} onChange={handleInputChange} required />
                                    </div>
                                    <div className="vec-form-group">
                                        <label>Modelo</label>
                                        <input type="text" name="modelo" value={formData.modelo} onChange={handleInputChange} required />
                                    </div>
                                </div>
                                <div className="vec-form-row">
                                    <div className="vec-form-group">
                                        <label>Ano</label>
                                        <input type="number" name="ano" value={formData.ano} onChange={handleInputChange} required />
                                    </div>
                                    <div className="vec-form-group">
                                        <label>Status Inicial</label>
                                        <select name="status" value={formData.status} onChange={handleInputChange}>
                                            <option value="Disponível">Disponível</option>
                                            <option value="Em Serviço">Em Serviço</option>
                                            <option value="Manutenção">Manutenção</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="vec-form-group">
                                    <label>Motorista Fixo (Opcional)</label>
                                    <select name="motorista_id" value={formData.motorista_id} onChange={handleInputChange}>
                                        <option value="">Nenhum</option>
                                        {motoristas.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
                                    </select>
                                </div>
                            </div>
                            <footer className="vec-modal-footer">
                                <button type="button" className="vec-btn vec-btn-outline" onClick={handleCloseAddModal}>Cancelar</button>
                                <button type="submit" className="vec-btn vec-btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvando...' : 'Cadastrar na Frota'}
                                </button>
                            </footer>
                        </form>
                    </div>
                </div>
            )}

            {/* ══════════════════════════════════════════════════
                MODAL — IMPORTAR MANUTENÇÕES FROTA
            ══════════════════════════════════════════════════ */}
            {mfImportOpen && (
                <div className="vec-modal-overlay" onClick={closeMfImportModal}>
                    <div className="vec-modal-content vec-modal-content--mf" onClick={(e) => e.stopPropagation()}>
                        <header className="vec-modal-header">
                            <h2><FaWrench /> Importar Manutenções</h2>
                            <button className="vec-close" onClick={closeMfImportModal}><FaTimes /></button>
                        </header>

                        <div className="vec-modal-body">

                            <div className="vec-form-group vec-form">
                                <label>Veículo de destino</label>
                                <select
                                    value={mfVeiculoId}
                                    onChange={(e) => {
                                        setMfVeiculoId(e.target.value);
                                        setMfResult(null);
                                        setMfShowErros(false);
                                    }}
                                >
                                    <option value="">Selecione o veículo...</option>
                                    {veiculos.map((v) => (
                                        <option key={v.id} value={v.id}>
                                            {v.placa} — {v.marca} {v.modelo}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button
                                type="button"
                                className="vec-btn vec-btn-outline"
                                style={{ width: '100%', justifyContent: 'center' }}
                                onClick={() => handleDownloadTemplateMf(mfVeiculoSelecionado?.placa)}
                            >
                                <FaFileDownload /> Baixar modelo de planilha (.csv)
                            </button>

                            <input
                                id="mf-file-global"
                                ref={mfFileRef}
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: 'none' }}
                                onChange={(e) => handleMfFileSelect(e.target.files?.[0])}
                            />
                            <label
                                htmlFor="mf-file-global"
                                className={`vec-mf-dropzone ${mfIsDragging ? 'is-dragging' : ''} ${mfFile ? 'has-file' : ''}`}
                                onDragOver={(e) => { e.preventDefault(); setMfIsDragging(true); }}
                                onDragLeave={(e) => { e.preventDefault(); setMfIsDragging(false); }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    setMfIsDragging(false);
                                    handleMfFileSelect(e.dataTransfer.files?.[0]);
                                }}
                            >
                                {mfFile ? (
                                    <>
                                        <FaFileExcel className="vec-mf-dropzone-icon" />
                                        <span className="vec-mf-dropzone-filename"><FaCheckCircle /> {mfFile.name}</span>
                                        <span className="vec-mf-dropzone-sub">Clique para trocar o arquivo</span>
                                    </>
                                ) : (
                                    <>
                                        <FaCloudUploadAlt className="vec-mf-dropzone-icon" />
                                        <span className="vec-mf-dropzone-title">Arraste a planilha aqui ou clique para escolher</span>
                                        <span className="vec-mf-dropzone-sub">Formatos aceitos: .xlsx · .xls · .csv</span>
                                    </>
                                )}
                            </label>

                            <p className="vec-mf-hint">
                                Colunas: <code>data</code>, <code>servico</code>, <code>valor</code>, <code>oficina</code>, <code>cnpj</code>, <code>descricao</code>.{' '}
                                <strong>data e valor</strong> são obrigatórias. A oficina é vinculada automaticamente
                                quando o nome ou CNPJ baterem com um parceiro cadastrado. Tudo é importado
                                para o veículo selecionado com status <strong>Concluído</strong>.
                            </p>

                            {mfResult && (
                                <div className={`vec-mf-result ${mfResult.status}`}>
                                    <div className="vec-mf-result-head">
                                        {mfResult.status === 'ok' ? <FaCheckCircle /> : mfResult.status === 'partial' ? <FaExclamationTriangle /> : <FaTimes />}
                                        <span>{mfResult.message}</span>
                                    </div>
                                    <div className="vec-mf-stats">
                                        <div className="vec-mf-stat ins"><strong>{mfResult.inseridos}</strong><span>Importadas</span></div>
                                        {mfResult.duplicados > 0 && <div className="vec-mf-stat ign"><strong>{mfResult.duplicados}</strong><span>Duplicadas</span></div>}
                                        <div className="vec-mf-stat ign"><strong>{mfResult.ignorados}</strong><span>Ignoradas</span></div>
                                    </div>
                                    {mfResult.detalhes?.length > 0 && (
                                        <>
                                            <button type="button" className="vec-mf-errors-toggle" onClick={() => setMfShowErros((v) => !v)}>
                                                <FaListUl /> {mfShowErros ? 'Ocultar detalhes' : `Ver ${mfResult.detalhes.length} linha(s) ignorada(s)`}
                                            </button>
                                            {mfShowErros && (
                                                <div className="vec-mf-errors">
                                                    <div className="vec-mf-errors-title"><FaExclamationTriangle /> Linhas não importadas</div>
                                                    <ul>{mfResult.detalhes.map((d, i) => <li key={i}>{d}</li>)}</ul>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <footer className="vec-modal-footer">
                            <button type="button" className="vec-btn vec-btn-outline" onClick={closeMfImportModal}>Fechar</button>
                            <button type="button" className="vec-btn vec-btn-primary" onClick={handleImportManutencoesFrota} disabled={mfIsImporting || !mfFile || !mfVeiculoId}>
                                {mfIsImporting ? <><FaSpinner className="fa-spin" /> Importando...</> : <><FaCloudUploadAlt /> Importar manutenções</>}
                            </button>
                        </footer>
                    </div>
                </div>
            )}

            {/* ══════════════════════════════════════════════════
                MODAL — IMPORTAR ABASTECIMENTOS (BLB)
            ══════════════════════════════════════════════════ */}
            {abastImportOpen && (
                <div className="vec-modal-overlay" onClick={closeAbastImportModal}>
                    <div className="vec-modal-content vec-modal-content--mf" onClick={(e) => e.stopPropagation()}>
                        <header className="vec-modal-header">
                            <h2><FaGasPump /> Importar Abastecimentos</h2>
                            <button className="vec-close" onClick={closeAbastImportModal}><FaTimes /></button>
                        </header>

                        <div className="vec-modal-body">
                            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                                <button
                                    type="button"
                                    className={`vec-btn ${abastFormato === 'blb' ? 'vec-btn-primary' : 'vec-btn-outline'}`}
                                    style={{ flex: 1, justifyContent: 'center' }}
                                    onClick={() => { setAbastFormato('blb'); setAbastResult(null); setAbastShowErros(false); }}
                                >
                                    <FaFileExcel /> Modelo BLB
                                </button>
                                <button
                                    type="button"
                                    className={`vec-btn ${abastFormato === 'sem_parar' ? 'vec-btn-primary' : 'vec-btn-outline'}`}
                                    style={{ flex: 1, justifyContent: 'center' }}
                                    onClick={() => { setAbastFormato('sem_parar'); setAbastResult(null); setAbastShowErros(false); }}
                                >
                                    <FaGasPump /> Sem Parar (combustível)
                                </button>
                            </div>

                            {abastFormato === 'blb' ? (
                                <button type="button" className="vec-btn vec-btn-outline" style={{ width: '100%', justifyContent: 'center' }} onClick={handleDownloadTemplateAbast}>
                                    <FaFileDownload /> Baixar modelo de planilha (.xlsx)
                                </button>
                            ) : (
                                <p className="vec-mf-hint">
                                    <FaExclamationTriangle style={{ marginRight: 4 }} />
                                    Use esta opção apenas se o seu extrato Sem Parar contiver linhas de <strong>ABASTECIMENTO</strong>.
                                    Para pedágios e estacionamentos, use <strong>Ações → Sem Parar → Importar extrato</strong>.
                                </p>
                            )}

                            <input
                                id="abast-file-global"
                                ref={fileInputAbastRef}
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: 'none' }}
                                onChange={(e) => { handleAbastFileSelect(e.target.files?.[0]); if (fileInputAbastRef.current) fileInputAbastRef.current.value = ''; }}
                            />
                            <label
                                htmlFor="abast-file-global"
                                className={`vec-mf-dropzone ${abastIsDragging ? 'is-dragging' : ''} ${abastFile ? 'has-file' : ''}`}
                                onDragOver={(e) => { e.preventDefault(); setAbastIsDragging(true); }}
                                onDragLeave={(e) => { e.preventDefault(); setAbastIsDragging(false); }}
                                onDrop={(e) => { e.preventDefault(); setAbastIsDragging(false); handleAbastFileSelect(e.dataTransfer.files?.[0]); }}
                            >
                                {abastFile ? (
                                    <>
                                        <FaFileExcel className="vec-mf-dropzone-icon" />
                                        <span className="vec-mf-dropzone-filename"><FaCheckCircle /> {abastFile.name}</span>
                                        <span className="vec-mf-dropzone-sub">Clique para trocar o arquivo</span>
                                    </>
                                ) : (
                                    <>
                                        <FaCloudUploadAlt className="vec-mf-dropzone-icon" />
                                        <span className="vec-mf-dropzone-title">Arraste a planilha aqui ou clique para escolher</span>
                                        <span className="vec-mf-dropzone-sub">Formatos aceitos: .xlsx · .xls · .csv</span>
                                    </>
                                )}
                            </label>

                            {abastFormato === 'blb' ? (
                                <p className="vec-mf-hint">
                                    Colunas: <code>placa</code>, <code>data</code>, <code>litros</code>, <code>valor</code>,{' '}
                                    <code>odometro</code>, <code>tipo_combustivel</code>, <code>posto</code>, <code>observacao</code>.{' '}
                                    <strong>placa, data, litros e valor</strong> são obrigatórias; o restante é opcional.
                                </p>
                            ) : (
                                <p className="vec-mf-hint">
                                    Não precisa formatar nada: o leitor reconhece o cabeçalho do extrato sozinho. Transações repetidas já importadas são ignoradas automaticamente.
                                </p>
                            )}

                            {abastResult && (
                                <div className={`vec-mf-result ${abastResult.status}`}>
                                    <div className="vec-mf-result-head">
                                        {abastResult.status === 'ok' ? <FaCheckCircle /> : abastResult.status === 'partial' ? <FaExclamationTriangle /> : <FaTimes />}
                                        <span>{abastResult.message}</span>
                                    </div>
                                    <div className="vec-mf-stats">
                                        <div className="vec-mf-stat ins"><strong>{abastResult.inseridos}</strong><span>Importados</span></div>
                                        {abastResult.duplicados > 0 && <div className="vec-mf-stat ign"><strong>{abastResult.duplicados}</strong><span>Duplicados</span></div>}
                                        <div className="vec-mf-stat ign"><strong>{abastResult.ignorados}</strong><span>Ignorados</span></div>
                                    </div>
                                    {abastResult.detalhes?.length > 0 && (
                                        <>
                                            <button type="button" className="vec-mf-errors-toggle" onClick={() => setAbastShowErros((v) => !v)}>
                                                <FaListUl /> {abastShowErros ? 'Ocultar detalhes' : `Ver ${abastResult.detalhes.length} linha(s) ignorada(s)`}
                                            </button>
                                            {abastShowErros && (
                                                <div className="vec-mf-errors">
                                                    <div className="vec-mf-errors-title"><FaExclamationTriangle /> Linhas não importadas</div>
                                                    <ul>{abastResult.detalhes.map((d, i) => <li key={i}>{d}</li>)}</ul>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <footer className="vec-modal-footer">
                            <button type="button" className="vec-btn vec-btn-outline" onClick={closeAbastImportModal}>Fechar</button>
                            <button type="button" className="vec-btn vec-btn-primary" onClick={executarImportAbast} disabled={isImportingAbast || !abastFile}>
                                {isImportingAbast ? <><FaSpinner className="fa-spin" /> Importando...</> : <><FaCloudUploadAlt /> Importar abastecimentos</>}
                            </button>
                        </footer>
                    </div>
                </div>
            )}

            {/* ══════════════════════════════════════════════════
                MODAL — IMPORTAR EXTRATO SEM PARAR    ← NOVO
                Rota: POST /api/vehicles/sem-parar/import
                Tabela: gastos_sem_parar
                Importa: PASSAGENS, ESTACIONAMENTO, PLANO CONTRATADO
            ══════════════════════════════════════════════════ */}
            {spImportOpen && (
                <div className="vec-modal-overlay" onClick={closeSpImportModal}>
                    <div className="vec-modal-content vec-modal-content--mf" onClick={(e) => e.stopPropagation()}>
                        <header className="vec-modal-header">
                            <h2><FaRoad /> Importar Extrato Sem Parar</h2>
                            <button className="vec-close" onClick={closeSpImportModal}><FaTimes /></button>
                        </header>

                        <div className="vec-modal-body">

                            {/* Info — o que este modal importa */}
                            <div style={{
                                background: 'var(--bg-secondary, #1e2130)',
                                border: '1px solid var(--border-color, #2d3148)',
                                borderRadius: 10,
                                padding: '14px 16px',
                                marginBottom: 14,
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, color: 'var(--text-primary, #e2e8f0)', fontWeight: 600, fontSize: '0.85rem' }}>
                                    <FaInfoCircle style={{ color: '#60a5fa', flexShrink: 0 }} />
                                    O que é importado do extrato
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                                    <SpTipoBadge tipo="PASSAGENS" />
                                    <SpTipoBadge tipo="ESTACIONAMENTO" />
                                    <SpTipoBadge tipo="PLANO CONTRATADO" />
                                    <SpTipoBadge tipo="ABASTECIMENTO" />
                                </div>
                                <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--text-secondary, #94a3b8)', lineHeight: 1.5 }}>
                                    Envie o arquivo <strong style={{ color: 'var(--text-primary, #e2e8f0)' }}>original do Sem Parar</strong> (.xlsx).
                                    O sistema detecta automaticamente as colunas (<em>Número da Fatura, Data, Horário, Placa Veículo, Tipo de uso, Descrição, Valor</em>),
                                    importa todos os lançamentos e vincula cada um à placa cadastrada na frota.
                                    Registros já importados são ignorados automaticamente.
                                </p>
                            </div>

                            {/* Dropzone */}
                            <input
                                id="sp-file-global"
                                ref={spFileRef}
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    handleSpFileSelect(e.target.files?.[0]);
                                    if (spFileRef.current) spFileRef.current.value = '';
                                }}
                            />
                            <label
                                htmlFor="sp-file-global"
                                className={`vec-mf-dropzone ${spIsDragging ? 'is-dragging' : ''} ${spFile ? 'has-file' : ''}`}
                                onDragOver={(e) => { e.preventDefault(); setSpIsDragging(true); }}
                                onDragLeave={(e) => { e.preventDefault(); setSpIsDragging(false); }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    setSpIsDragging(false);
                                    handleSpFileSelect(e.dataTransfer.files?.[0]);
                                }}
                            >
                                {spFile ? (
                                    <>
                                        <FaFileExcel className="vec-mf-dropzone-icon" style={{ color: '#22c55e' }} />
                                        <span className="vec-mf-dropzone-filename">
                                            <FaCheckCircle style={{ color: '#22c55e' }} /> {spFile.name}
                                        </span>
                                        <span className="vec-mf-dropzone-sub">Clique para trocar o arquivo</span>
                                    </>
                                ) : (
                                    <>
                                        <FaRoad className="vec-mf-dropzone-icon" style={{ color: '#60a5fa' }} />
                                        <span className="vec-mf-dropzone-title">Arraste o extrato aqui ou clique para escolher</span>
                                        <span className="vec-mf-dropzone-sub">Arquivo original do Sem Parar · .xlsx recomendado</span>
                                    </>
                                )}
                            </label>

                            {/* Hint técnico */}
                            <div className="vec-mf-hint" style={{ marginTop: 8 }}>
                                <strong>Colunas reconhecidas:</strong>{' '}
                                <code>Número da Fatura</code>, <code>Data</code>, <code>Horário</code>,{' '}
                                <code>Placa Veículo</code>, <code>Tipo de uso</code>, <code>Descrição</code>,{' '}
                                <code>Valor(R$)</code>, <code>Sentido da Praça</code>.{' '}
                                Placas não cadastradas na frota são importadas <em>sem vínculo de veículo</em> — aparecem
                                na guia Sem Parar apenas quando o veículo for cadastrado e a placa bater.
                            </div>

                            {/* Resultado da importação */}
                            {spResult && (
                                <div className={`vec-mf-result ${spResult.status}`} style={{ marginTop: 14 }}>
                                    <div className="vec-mf-result-head">
                                        {spResult.status === 'ok'
                                            ? <FaCheckCircle />
                                            : spResult.status === 'partial'
                                            ? <FaExclamationTriangle />
                                            : <FaTimes />}
                                        <span>{spResult.message}</span>
                                    </div>

                                    {/* Stats principais */}
                                    <div className="vec-mf-stats">
                                        <div className="vec-mf-stat ins">
                                            <strong>{spResult.inseridos}</strong>
                                            <span>Importados</span>
                                        </div>
                                        {spResult.duplicados > 0 && (
                                            <div className="vec-mf-stat ign">
                                                <strong>{spResult.duplicados}</strong>
                                                <span>Duplicados</span>
                                            </div>
                                        )}
                                        {spResult.ignorados > 0 && (
                                            <div className="vec-mf-stat ign">
                                                <strong>{spResult.ignorados}</strong>
                                                <span>Ignorados</span>
                                            </div>
                                        )}
                                        {spResult.semVeiculo > 0 && (
                                            <div className="vec-mf-stat" style={{
                                                background: 'rgba(234,179,8,0.12)',
                                                border: '1px solid rgba(234,179,8,0.3)',
                                                borderRadius: 8, padding: '8px 14px',
                                                textAlign: 'center', minWidth: 64,
                                            }}>
                                                <strong style={{ color: '#fbbf24', display: 'block', fontSize: '1.2rem', fontWeight: 700 }}>
                                                    {spResult.semVeiculo}
                                                </strong>
                                                <span style={{ fontSize: '0.72rem', color: '#fbbf24', opacity: 0.85 }}>Sem veículo</span>
                                            </div>
                                        )}
                                    </div>

                                    {/* Aviso sobre placas fora da frota */}
                                    {spResult.semVeiculo > 0 && (
                                        <div style={{
                                            display: 'flex', alignItems: 'flex-start', gap: 8,
                                            background: 'rgba(234,179,8,0.08)',
                                            border: '1px solid rgba(234,179,8,0.25)',
                                            borderRadius: 8, padding: '10px 12px',
                                            fontSize: '0.78rem', color: '#fde68a',
                                            marginTop: 8,
                                        }}>
                                            <FaExclamationTriangle style={{ flexShrink: 0, marginTop: 1 }} />
                                            <span>
                                                {spResult.semVeiculo} lançamento(s) foram importados sem vínculo de veículo
                                                porque a placa não estava cadastrada na frota. Cadastre os veículos
                                                e os registros aparecerão automaticamente na guia Sem Parar de cada um.
                                            </span>
                                        </div>
                                    )}

                                    {/* Detalhes de erros reais */}
                                    {spResult.erros?.length > 0 && (
                                        <>
                                            <button
                                                type="button"
                                                className="vec-mf-errors-toggle"
                                                onClick={() => setSpShowErros((v) => !v)}
                                            >
                                                <FaListUl />
                                                {spShowErros
                                                    ? 'Ocultar detalhes'
                                                    : `Ver ${spResult.erros.length} linha(s) com erro`}
                                            </button>
                                            {spShowErros && (
                                                <div className="vec-mf-errors">
                                                    <div className="vec-mf-errors-title">
                                                        <FaExclamationTriangle /> Linhas não importadas
                                                    </div>
                                                    <ul>
                                                        {spResult.erros.map((d, i) => <li key={i}>{d}</li>)}
                                                    </ul>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <footer className="vec-modal-footer">
                            <button type="button" className="vec-btn vec-btn-outline" onClick={closeSpImportModal}>
                                Fechar
                            </button>
                            <button
                                type="button"
                                className="vec-btn vec-btn-primary"
                                onClick={executarImportSemParar}
                                disabled={spIsImporting || !spFile}
                            >
                                {spIsImporting
                                    ? <><FaSpinner className="fa-spin" /> Importando...</>
                                    : <><FaRoad /> Importar extrato Sem Parar</>}
                            </button>
                        </footer>
                    </div>
                </div>
            )}

            {/* ══════════════════════════════════════════════════
                MODAIS COMPLEMENTARES
            ══════════════════════════════════════════════════ */}
            {selectedVeiculo && (
                <VeiculoDetalhesModal veiculo={selectedVeiculo} onClose={() => setSelectedVeiculo(null)} />
            )}

            {editingVeiculo && (
                <VeiculoEditModal
                    veiculo={editingVeiculo}
                    motoristas={motoristas}
                    onClose={() => setEditingVeiculo(null)}
                    onSave={() => { setEditingVeiculo(null); fetchVeiculos(pagination.currentPage); }}
                />
            )}

            {isLoteAbastecimentoOpen && (
                <AbastecimentoLoteModal
                    veiculos={veiculos}
                    motoristas={motoristas}
                    preSelecionados={selectedVehicles}
                    onClose={() => setIsLoteAbastecimentoOpen(false)}
                    onSuccess={() => { setSelectedVehicles([]); fetchVeiculos(pagination.currentPage); }}
                />
            )}

            {isAbastManualOpen && (
                <AbastecimentoManualModal
                    veiculos={veiculos}
                    motoristas={motoristas}
                    onClose={() => setIsAbastManualOpen(false)}
                    onSuccess={() => fetchVeiculos(pagination.currentPage)}
                />
            )}

            {showMonitor && (
                <MonitorUsoDiarioModal onClose={() => setShowMonitor(false)} />
            )}

            {isSuccessModalVisible && (
                <SuccessModal message={successMessage} onClose={() => setIsSuccessModalVisible(false)} />
            )}
        </main>
    );
}